// import React, { useEffect, useMemo, useState } from "react";
// import { DataGrid } from "@mui/x-data-grid";
// import Box from "@mui/material/Box";

// const InventoryValidationTable = ({
//   additionalData,
//   pagination,
//   showDrawer,
//   totalCount,        // ← new prop
// }) => {
//   const data = useMemo(() => additionalData || [], [additionalData]);

//   const [paginationModel, setPaginationModel] = useState({
//     page: 0,
//     pageSize: 10,
//   });

//   useEffect(() => {
//     pagination({
//       limit: paginationModel.pageSize,
//       offset: paginationModel.pageSize * paginationModel.page,
//     });
//   }, [paginationModel]);

//   const muiColumns = useMemo(
//     () => [
//       { field: "id", headerName: "ID", flex: 1 },
//       { field: "create_date",     headerName: "Create Date", flex: 2 },
//       { field: "no_of_items",     headerName: "No. of Items", flex: 1 },
//     ],
//     []
//   );

//   return (
//     <Box  sx={{
//                 height: 600,
//                 width: "100%",
//                 "& .MuiDataGrid-root": {
//                   border: "none",
//                   borderRadius: "12px",
//                   overflow: "hidden",
//                   fontFamily: "'Inter', sans-serif",
//                   fontSize: "13px",
//                   boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
//                   backgroundColor: "#fff",
//                 },
//                 "& .MuiDataGrid-columnHeaders": {
//                   backgroundColor: "#EBF7FD",
//                   borderBottom: "1.5px solid #78CFEC",
//                   minHeight: "48px !important",
//                 },
//                 "& .MuiDataGrid-columnHeader": {
//                   padding: "0 16px",
//                   color: "#1A6F8A",
//                   fontWeight: 600,
//                   fontSize: "12.5px",
//                   textTransform: "uppercase",
//                   letterSpacing: "0.04em",
//                 },
//                 "& .MuiDataGrid-columnSeparator": {
//                   display: "none",
//                 },
//                 "& .MuiDataGrid-cell": {
//                   padding: "0 16px",
//                   borderBottom: "1px solid #F0F4F8",
//                   color: "#272728",
//                   display: "flex",
//                   alignItems: "center",
//                 },
//                 "& .MuiDataGrid-row": {
//                   minHeight: "52px !important",
//                   transition: "background 0.15s ease",
//                 },
//                 "& .MuiDataGrid-row:hover": {
//                   backgroundColor: "#F0F9FD",
//                   cursor: "pointer",
//                 },
//                 "& .MuiDataGrid-row.Mui-selected": {
//                   backgroundColor: "#DBEEFA !important",
//                 },
//                 "& .MuiDataGrid-row.Mui-selected:hover": {
//                   backgroundColor: "#CCE8F6 !important",
//                 },
//                 "& .MuiDataGrid-checkboxInput": {
//                   color: "#78CFEC",
//                 },
//                 "& .MuiCheckbox-root.Mui-checked": {
//                   color: "#0EA5D0",
//                 },
//                 "& .MuiDataGrid-footerContainer": {
//                   borderTop: "1.5px solid #E2EEF4",
//                   backgroundColor: "#F7FBFD",
//                   minHeight: "48px",
//                 },

//                 "& .MuiDataGrid-virtualScroller": {
//                   backgroundColor: "#FAFCFE",
//                 },
//                 "& .MuiDataGrid-overlayWrapper": {
//                   minHeight: "120px",
//                 },
//                 "& .MuiDataGrid-columnHeaderTitleContainer": {
//                   gap: "4px",
//                 },
//                 "& .MuiDataGrid-sortIcon": {
//                   color: "#78CFEC",
//                 },
//                 "& .MuiDataGrid-menuIcon": {
//                   color: "#78CFEC",
//                 },

//                 "& .MuiTablePagination-selectLabel": {
//                   display: "none",   // hides "Rows per page"
//                 },
//               }}>
//     <DataGrid
//   rows={data}
//   columns={muiColumns}
//   getRowId={(row) => row.id}
//   onRowClick={(params) => showDrawer(params.row)}
//   disableRowSelectionOnClick
//   paginationMode="server"
//   rowCount={totalCount ?? 0}
//   paginationModel={paginationModel}
//   onPaginationModelChange={setPaginationModel}
//   pageSizeOptions={[10, 25, 50]}
// />
//     </Box>
//   );
// };

// export default InventoryValidationTable;


import React, { useEffect, useMemo, useState, useCallback } from "react";
import { useTable, useSortBy, usePagination, useRowSelect } from "react-table";
import "tailwindcss/tailwind.css";
import { Empty, Input, Modal, Button, Form } from "antd";
import "../../styles.css";
import Vectorsorting from "../../assets/Vectorsorting.svg";
import ShimmerLoader from "../../loading";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import CustomPagination from "../../components/CustomWidgets/CustomPagination";
import arrowright from "../../assets/arrowright.svg";
import { useSelector } from "react-redux";
import Edit from "../../assets/Edit.svg";
import deleteicon from "../../assets/Order/Delete.svg";

const InventoryValidationTable = ({
     additionalData,
  pagination,
  showDrawer,
  totalCount,
  isSelectMode,
  selectedRecords,
  onToggleSelect,
  onSelectAll,
}) => {
    const { t, i18n } = useTranslation();
    const [flag, setFlag] = useState(false);

    const data = useMemo(() => additionalData || [], [additionalData]);

    useEffect(() => {
        if (additionalData?.length === 0 && !flag) {
            const timer = setTimeout(() => {
                setFlag(true);
            }, 1000);
            return () => clearTimeout(timer);
        }
    }, [additionalData, flag]);




  

    //   const muiColumns = useMemo(
//     () => [
//       { field: "id", headerName: "ID", flex: 1 },
//       { field: "create_date",     headerName: "Create Date", flex: 2 },
//       { field: "no_of_items",     headerName: "No. of Items", flex: 1 },
//     ],
//     []
//   );

const allSelected =
    data?.length > 0 &&
    data.every((record) => selectedRecords?.includes(record.id));

const columns = useMemo(() => {
    const selectColumn = isSelectMode
        ? [
              {
                  id: "select",
                  Header: () => (
                      <input
                          type="checkbox"
                          checked={allSelected}
                          onChange={(e) => onSelectAll && onSelectAll(e.target.checked)}
                          onClick={(e) => e.stopPropagation()}
                          className="cursor-pointer w-4 h-4 accent-[#465466]"
                      />
                  ),
                  width: "6%",
                  disableSortBy: true,
                  Cell: ({ row }) => (
                      <div className="text-start">
                          <input
                              type="checkbox"
                              checked={selectedRecords?.includes(row.original.id)}
                              onChange={() =>
                                  onToggleSelect && onToggleSelect(row.original.id)
                              }
                              onClick={(e) => e.stopPropagation()}
                              className="cursor-pointer w-4 h-4 accent-[#465466]"
                          />
                      </div>
                  ),
              },
          ]
        : [];

    const baseColumns = [{
                Header: t("ID"),
                accessor: "id",
                width: "10%",
                Cell: ({ row }) => (
                    <div className="text-start">{row.original?.id}</div>
                ),
            },
            {
            Header: t("User"),
            accessor: "user",
            width: "20%",
            Cell: ({ row }) => (
                <div className="text-start">{row.original?.user}</div>
            ),
        },
        {
            Header: t("Email"),
            accessor: "email",
            width: "20%",
            Cell: ({ row }) => (
                <div className="text-start">{row.original?.email}</div>
            ),
        },
        {
            Header: t("Phone"),
            accessor: "phone",
            width: "20%",
            Cell: ({ row }) => (
                <div className="text-start">{row.original?.phone}</div>
            ),
        },

        {
            Header: t("Create Date"),
            accessor: "create_date",
            width: "20%",
            Cell: ({ row }) => (
                <div className="text-start">{row.original?.create_date}</div>
            ),
        },
        {
            Header: t("No. of Items"),
            accessor: "no_of_items",
            width: "20%",
            Cell: ({ row }) => (
                <div className="text-start">{row.original?.no_of_items}</div>
            ),
        },
    ];

    const arrowColumn = [{
        id: "arrow",
        disableSortBy: true,
        Header: "",
        width: "4%",
        Cell: ({ row }) => (
            <button className="text-[#1b4497] rounded-lg">
                <img
                    src={arrowright}
                    alt="arrowright"
                    className={`${i18n.language === "en" ? "" : "rotate-180"}`}
                    width={20}
                />
            </button>
        ),
    }];

    return [...selectColumn, ...baseColumns, ...arrowColumn];
}, [t, i18n.language, isSelectMode, selectedRecords, allSelected, onSelectAll, onToggleSelect]);


    const {
        headerGroups,
        prepareRow,
        page,
        nextPage,
        setPageSize,
        state: { pageSize },
    } = useTable(
        {
            columns,
            data: data,
            initialState: { pageSize: 10 },
        },
        useSortBy,
        usePagination,
        useRowSelect
    );

    const [pageIndex, setpageIndex] = useState(1);

    useEffect(() => {
        const pageDetails = {
            limit: pageSize,
            offset: pageSize * (pageIndex - 1) < 0 ? 0 : pageSize * (pageIndex - 1),
        };

        if (pageSize) pagination(pageDetails);
    }, [pageSize, pageIndex]);


    return (
        <div
            className="container flex flex-col mx-auto mt-4"
            style={{ maxWidth: "100%" }}
        >
            {additionalData?.length === 0 && !flag ? (
                <div className="h-screen w-[90%] mt-2 ">
                    <ShimmerLoader />
                </div>
            ) : (
                <>
                    {/* Header */}
                    <table
                        className="font-normal max-w-[100%] sm:w-[97.6%] md:w-[97.6%] lg:w-[97.6%] xl:w-[97.6%] overflow-hidden rounded-lg"
                        style={{ tableLayout: "fixed" }}
                    >
                        <thead>
                            {headerGroups.map((headerGroup) => (
                                <tr
                                    key={headerGroup.id}
                                    {...headerGroup.getHeaderGroupProps()}
                                    className="bg-[#78CFEC66] text-sm font-semibold overflow-hidden whitespace-nowrap"
                                >
                                    {headerGroup.headers.map((column) => (
                                        <th
                                            key={column.id}
                                            {...column.getHeaderProps(column.getSortByToggleProps())}
                                            className="py-3 whitespace-nowrap"
                                            style={{ width: column.width }}
                                        >
                                            <div className="flex flex-row items-center ms-2 text-sm leading-tight ">
                                                                           {column.render("Header")}
                                                                           {column.canSort && (
                                                                             <span className="ms-1">
                                                                               {column.isSorted ? (
                                                                                 column.isSortedDesc ? (
                                                                                   <img
                                                                                     src={Vectorsorting}
                                                                                     style={{
                                                                                       minHeight: 10,
                                                                                       minWidth: 10,
                                                                                     }}
                                                                                     alt="vector"
                                                                                   />
                                                                                 ) : (
                                                                                   <img
                                                                                     className="rotate-180"
                                                                                     src={Vectorsorting}
                                                                                     alt="vector"
                                                                                   />
                                                                                 )
                                                                               ) : (
                                                                                 // 👇 Show a neutral icon when column is not sorted
                                                                                 <img
                                                                                   src={Vectorsorting}
                                                                                   alt="sortable"
                                                                                   style={{
                                                                                     minHeight: 10,
                                                                                     minWidth: 10,
                                                                                     opacity: 0.3,
                                                                                   }}
                                                                                 />
                                                                               )}
                                                                             </span>
                                                                           )}
                                                                         </div>
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                    </table>

                    {/* Body */}
                    <div
                        className="scrollbar-none bg-[#F7F9FD]"
                        style={{ overflowY: "auto", maxHeight: "600px" }}
                    >
                        <table
                            className="font-normal max-w-[100%] sm:w-[97.6%] md:w-[97.6%] lg:w-[97.6%] xl:w-[97.6%] overflow-hidden rounded-lg"
                            style={{ tableLayout: "fixed" }}
                        >
                            <tbody className="bg-[#F7F9FD] text-center overflow-hidden">
                                {page.map((row) => {
                                    prepareRow(row);
                                    return (
                                        <tr
                                            key={row.id}
                                            {...row.getRowProps()}
                                            className="relative hover:bg-white cursor-pointer transition duration-300 border-b border-gray-300 fixed-row-height"
                                            onClick={() =>
                                                isSelectMode
                                                    ? onToggleSelect && onToggleSelect(row.original.id)
                                                    : showDrawer && showDrawer(row.original)
                                            }
                                        >
                                            {row.cells.map((cell, index) => (
                                                <td
                                                    key={index}
                                                    {...cell.getCellProps()}
                                                    className={`p-2 text-[#272728] h-1212 text-sm font-normal ${index < row.cells.length - 1 ? "relative" : ""
                                                        }`}
                                                    style={{ width: cell.column.width }}
                                                >
                                                    {cell.render("Cell")}
                                                </td>
                                            ))}
                                        </tr>
                                    );
                                })}
                                {page.length === 0 && (
                                    <tr>
                                        <td colSpan={"100%"}>
                                            <Empty
                                                className="mt-10"
                                                description={t("No data available")}
                                            />
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination */}
                    <div className="">
                        <CustomPagination
                            data={data?.length}
                            pageIndex={pageIndex}
                            pageCount={page?.length}
                            canPreviousPage={pageIndex != 1 ? true : false}
                            canNextPage={data?.length == pageSize ? true : false}
                            gotoPage={(page) => {
                                nextPage(page);
                            }}
                            previousPage={() => {
                                setpageIndex(pageIndex - 1);
                            }}
                            nextPage={() => {
                                setpageIndex(pageIndex + 1);
                            }}
                            pageSize={pageSize}
                            setPageSize={(pageSize) => {
                                setPageSize(pageSize);
                            }}
                        />
                    </div>
                </>
            )}

           


        </div>
    );
};

export default InventoryValidationTable;
